module.exports = __webpack_public_path__ + "static/media/stockhausen_held_1.abeb26a6.png";